export const PERMISSIONS = new Set(window.clutter.user?.granted_permissions ?? []);
